



















































































import {Component, Vue, Watch} from "vue-property-decorator";
import Select from "@/components/Form/elements/Select.vue";
import AppConfig from "@/config/AppConfig";
import TimeSpent from "@/views/Service/TimeTracking/Reports/TimeSpent.vue";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import {Action, Getter} from "vuex-class";
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import ApiService from "@/service/ApiService";
import TypesReport from "@/views/Service/TimeTracking/Reports/TypesReport.vue";
import Exports from "@/views/Service/TimeTracking/Reports/Exports.vue";

const NAMESPACE_TIME_TRACKING_REPORTS: string = 'timeTrackingReports';
const RESOURCE_TIME_TRACKING_REPORTS: string = '/tt/reports';

@Component({
  components: {Exports, TypesReport, TimeSpent, Select, VueCtkDateTimePicker}
})
export default class Reports extends Vue {
  public name: string = "Reports";

  @Action('loadTimeSpentReport', {namespace: NAMESPACE_TIME_TRACKING_REPORTS}) loadTimeSpentReport;
  @Action('exportTimeSpentReport', {namespace: NAMESPACE_TIME_TRACKING_REPORTS}) exportTimeSpentReport;

  @Getter('getTimeSpentReport', {namespace: NAMESPACE_TIME_TRACKING_REPORTS}) getTimeSpentReport;

  private apiService: ApiService = new ApiService();

  private from: string = '';
  private to: string = '';

  private reportTypeSelect: string = '';
  private reportDateUnitSelect: string = 'month';

  private typesReport: any = null;

  @Watch('reportTypeSelect', {immediate: false})
  private onReportTypeSelectChanged(): void {

    if (this.reportTypeSelect !== '') {
      this.fetchData();
    }

  }

  @Watch('reportDateUnitSelect', {immediate: false})
  private onReportDateUnitSelectChanged(): void {

    if (this.reportDateUnitSelect !== '') {
      this.fetchData();
    }

  }

  @Watch('from', {immediate: false})
  private onFromChanged(): void {

    if (this.from !== '') {
      this.fetchData();
    }

  }

  @Watch('to', {immediate: false})
  private onToChanged(): void {

    if (this.to !== '') {
      this.fetchData();
    }

  }

  private get params(): any {

    return {

      report_type: this.reportTypeSelect,
      date_unit: this.reportDateUnitSelect,
      from: this.from,
      to: this.to,

    }

  }

  private get reportTypeSelectOptions(): any {

    return AppConfig.getConfig('Selects.timetracking_reports.reportTypeSelectOptions');

  }

  private get reportDateUnitSelectOptions(): any {

    return AppConfig.getConfig('Selects.timetracking_reports.reportDateUnitsSelectOptions');

  }

  private setStart(startPoint: string): void {

    this.from = this.getDate(startPoint);

  }

  private setEnd(endPoint: string): void {

    this.to = this.getDate(endPoint);

  }

  private getDate(by: string) {

    let date: any = this.$moment;

    switch (by) {

      case 'start_of_month':
        date = this.$moment().clone().startOf('month').format(AppConfig.DATETIME_FORMAT_SQL);
        break;
      case 'start_of_year':
        date = this.$moment().clone().startOf('year').format(AppConfig.DATETIME_FORMAT_SQL);
        break;
      case 'end_of_month':
        date = this.$moment().clone().endOf('month').format(AppConfig.DATETIME_FORMAT_SQL);
        break;
      case 'end_of_year':
        date = this.$moment().clone().endOf('year').format(AppConfig.DATETIME_FORMAT_SQL);
        break;
    }

    return date;

  }

  private fetchData(isExport: boolean = false): void {

    let params: any = this.params;

    params.is_export = isExport ? 1 : 0;

    switch (this.reportTypeSelect) {

      case 'timeSpent':

        if (isExport) {

          this.exportTimeSpentReport({resource: RESOURCE_TIME_TRACKING_REPORTS, params})

        } else {

          this.loadTimeSpentReport({resource: RESOURCE_TIME_TRACKING_REPORTS, params})

        }

        break;

      case 'by_type':

        this.apiService.get(RESOURCE_TIME_TRACKING_REPORTS + '/type', params).then((response: any) => {

          if (!isExport) {

            this.typesReport = response.data;

          }

        })

        break;

    }

  }


  private doExport(): void {

    this.fetchData(true);

  }

  private init(): void {

    this.from = this.$moment().clone().startOf('year').format(AppConfig.DATETIME_FORMAT_SQL);
    this.to = this.$moment().clone().endOf('month').format(AppConfig.DATETIME_FORMAT_SQL);

  }

  private onMassExport(paramsList: Array<any>) {

    this.apiService.post(RESOURCE_TIME_TRACKING_REPORTS + '/mass-export', paramsList);

  }

  created() {

    this.init();

  }


}
